import { buildExtractionProgressModel } from "@/lib/batchExtractionProgress";
import type { BatchExtractionStatus } from "@/services/api";

interface PipelineExtractionProgressBannerProps {
  batchStatus: BatchExtractionStatus;
  onCancelBatch?: () => void;
}

export function PipelineExtractionProgressBanner({
  batchStatus,
  onCancelBatch,
}: PipelineExtractionProgressBannerProps) {
  const progress = buildExtractionProgressModel(batchStatus);

  return (
    <div className="border-b border-[var(--color-border-light)] bg-[var(--color-bg-primary)] px-3 py-1.5 md:px-4">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1 space-y-0.5">
          <p
            className="text-xs font-medium text-[var(--color-text-primary)]"
            data-testid="pipeline-extraction-progress"
          >
            {progress.primaryLabel}
          </p>
          {progress.detailLabel ? (
            <p className="text-[11px] text-[var(--color-text-secondary)]">{progress.detailLabel}</p>
          ) : null}
        </div>
        {onCancelBatch ? (
          <button
            type="button"
            className="shrink-0 text-[11px] font-semibold text-[var(--color-text-primary)] underline-offset-2 hover:underline"
            onClick={onCancelBatch}
          >
            Cancel batch
          </button>
        ) : null}
      </div>
      <div className="mt-1.5 h-1 w-full overflow-hidden rounded-full bg-[var(--color-bg-tertiary)]">
        <div
          className="h-full rounded-full bg-[var(--color-brand-primary)] transition-all duration-300"
          style={{ width: `${progress.percent}%` }}
          role="progressbar"
          aria-valuenow={progress.percent}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={progress.primaryLabel}
        />
      </div>
    </div>
  );
}
